export const handleToggleDialog = (setActiveDialog, activeDialog) => () => {
  setActiveDialog(!activeDialog);
};
